import React, { useState } from "react";
import "./Start_Assessment.css";
import Header_Btn from "../../common/header-btn/Header_Btn";
import Start_Btn from "../../common/start-btn/Start_Btn";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";
import { useNavigate } from "react-router-dom";

const Start_Assessment = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  return (
    <section className="Start_Assessment">
      <div className="container">
        <div className="black_div">
          <h5 className="div_title">Ready to Make the Right Career Choice?</h5>
          <p className="div_subtitle">
            Take the first step toward clarity and confidence
          </p>
          <Start_Btn
            text="Start Assessment"
            onClick={() => navigate(`/test-instructions`)}
          />
        </div>
      </div>

      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </section>
  );
};

export default Start_Assessment;
